import React from "react";
import ReactPaginate from "react-paginate";
import './common.scss';

const Pagination = ({
  totalPages,
  handlePageChange,
  previousLabel = "Previous",
  nextLabel = "Next",
  currentPage, // Add currentPage prop
}) => {
  const handlePageClick = (data) => {
    let selectedPage = data.selected + 1;
    handlePageChange(selectedPage);
  };

  return (
    <div className="flex justify-end mt-5">
      <ReactPaginate
        previousLabel={currentPage === 1 ? "" : previousLabel}
        nextLabel={currentPage === totalPages ? "" : nextLabel}
        breakLabel={"..."}
        breakClassName={"break-me"}
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        subContainerClassName={"pages pagination"}
        previousClassName={(currentPage === 1 || !previousLabel) ? "pagination-hidden" : ""}
        nextClassName={(currentPage === totalPages || !nextLabel) ? "pagination-hidden" : ""}
        previousLinkClassName={currentPage === 1 ? "pagination-hidden" : "!bg-[#F0F0F0] !text-[#8C8C8C] !border !border-[#C4C4C4] !font-poppins !font-[400]"}
        nextLinkClassName={currentPage === totalPages ? "pagination-hidden" : "!bg-[#00ADEF] !text-white !text-center !font-poppins !font-[400] !px-3"}
        activeClassName={"active"}
        forcePage={currentPage ? currentPage - 1 : 0}
      />
    </div>
  );
};

export default Pagination;